import { Injectable } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { Store, select } from '@ngrx/store';
import * as fromRoot from '../reducers';
import { Subscription } from 'rxjs';
import { linkURLSanitizer } from '../util/blend-helper';

@Injectable({
  providedIn: 'root'
})
export class SentryService {

  private userId: number;
  private userSubscription: Subscription;
  constructor(
    private userService: UserService,
    private store: Store<fromRoot.State>,
    ) {
    // do not initialize in dev mode
     if (!environment.isDev) {
      this.initSentry();
    }
  }

  private initSentry() {
    Sentry.init({
      environment: environment?.production ? 'production' : 'staging',
      dsn: "https://dba09366bb96170e15c6da769829adf2@o4507827516342272.ingest.de.sentry.io/4508003053994064",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Tracing
      //  Capture 100% of the transactions
      tracesSampleRate: 1.0,
      // Session Replay
      // This disables replay session for non fatal events.
      replaysSessionSampleRate: 0.0,
      // Get replay sampling of 50% of errors.
      replaysOnErrorSampleRate: 0.5,
      beforeSend: (event) => {
        const is_disableanalytics = this.userService.user && this.userService.get('is_disableanalytics'); // Get the user from the event

        // Not sending events if user has disabled analytics
        if (is_disableanalytics) {
          return null; // Do not send the event
        }

        event.user = {
          id: this.userService.get('id')
        };

        // Scrub sensitive data from request URL
        if (event.request && event.request.url) {
          event.request.url = linkURLSanitizer(event.request.url);
        }

        // Scrub sensitive data from navigation breadcrumbs
        if (event.breadcrumbs) {
          event.breadcrumbs.forEach((breadcrumb, index) => {
            if (breadcrumb.category === 'navigation' && breadcrumb.data) {
              if (breadcrumb.data.from) {
                event.breadcrumbs[index].data.from =
                  linkURLSanitizer('https://sentry' + breadcrumb.data.from).substring(14);
              }
              if (breadcrumb.data.to) {
                event.breadcrumbs[index].data.to =
                  linkURLSanitizer('https://sentry' + breadcrumb.data.to).substring(14);
              }
            }
          });
        }

        return event;
      },
      beforeSendTransaction: (event) => {
        const is_disableanalytics = this.userService.user &&  this.userService.get('is_disableanalytics'); // Get the user from the event

        // Not sending events if user has disabled analytics
        if (is_disableanalytics) {
          return null; // Do not send the event
        }
        return event;
      },

    });

    this.userSubscription = this.store
    .pipe(select(fromRoot.getAuthUser))
    .subscribe((data) => {
      if (data && data.id) {
        if (this.userId !== data.id) {
          Sentry.setUser({
            id: data.id
          });
          this.userId = data.id;
        }
      }
    });
  }

  public logError(error: any, additionalContext: any) {
    if (!environment.isDev) {
      Sentry.captureException(error, (scope: Sentry.Scope) => {
        scope.setExtra('context', additionalContext);
        return scope;
      });
    }
  }
}
